module.exports = __webpack_public_path__ + "img/c04_unitscout_Normal_ua.6a00e3d8.webp";